import { createConfirmModalOptions } from 'modals/modal-options-factory';

export const createRestoreDefaultModalOptions = ({
  restoreToDefault,
  toggleModal
}) => {
  return createConfirmModalOptions({
    title: 'Restore default',
    description:
      'Are you sure you want to reset Incidents detection to the default value?',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    onConfirm: async () => {
      try {
        restoreToDefault();
        toggleModal();
      } catch (e) {}
    },
    onCancel: () => toggleModal()
  });
};
